import $ from "jquery";

export default function(callback) {
    let status = $('.points-search-section__localization-status');
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(callback);
    } else {
        status.innerHTML = "Geolocation is not supported by this browser.";
    }
}